<template>
    <Breadcrumb>
        <BreadcrumbItem 
            v-for="(item,index) in currentPath"
            :href="item.path" 
            :key="index"
        >{{ itemTitle(item) }}</BreadcrumbItem>
    </Breadcrumb>
</template>

<script>
export default {
    name: 'breadcrumbNav',
    props: {
        currentPath: Array
    },
    methods: {
        itemTitle (item) {
            if (typeof item.title === 'object') {
                return this.$t(item.title.i18n);
            } else {
                return item.title;
            }
        }
    }
};
</script>
<style lang="less" scoped>
 .ivu-breadcrumb a{
     color: #999;
 }
</style>





// WEBPACK FOOTER //
// src/views/main-components/breadcrumb-nav.vue